/* 
  Imagine Wishlist v7
  Fix: PDP wishlist now handles the first click immediately.
  Change: wishlist clicks run in capture phase and stop old/theme handlers from swallowing the first click.
*/
(function () {
  var STORAGE_KEY = "if_wishlist_v1";
  var INVENTORY_BUFFER = 3;
  var productCache = {};
  var lastWishlistPageSignature = "";

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];

      if (!Array.isArray(parsed)) return [];

      return parsed.filter(function (item) {
        return item && item.id;
      });
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {}
  }

  function normaliseId(value) {
    return String(value || "").trim();
  }

  function isInWishlist(productId) {
    productId = normaliseId(productId);

    return getWishlist().some(function (item) {
      return normaliseId(item.id) === productId;
    });
  }

  function addToWishlist(product) {
    var items = getWishlist();
    var productId = normaliseId(product.id);

    if (!productId) return items;

    var alreadyExists = items.some(function (item) {
      return normaliseId(item.id) === productId;
    });

    if (!alreadyExists) {
      items.unshift(product);
      saveWishlist(items);
    }

    return items;
  }

  function removeFromWishlist(productId) {
    productId = normaliseId(productId);

    var items = getWishlist().filter(function (item) {
      return normaliseId(item.id) !== productId;
    });

    saveWishlist(items);

    return items;
  }

  function clearWishlist() {
    saveWishlist([]);
    return [];
  }

  function getProductFromButton(button) {
    return {
      id: normaliseId(button.getAttribute("data-if-product-id")),
      handle: button.getAttribute("data-if-product-handle") || "",
      url: button.getAttribute("data-if-product-url") || "",
      title: button.getAttribute("data-if-product-title") || "",
      image: button.getAttribute("data-if-product-image") || "",
      price: button.getAttribute("data-if-product-price") || "",
      priceRaw: button.getAttribute("data-if-product-price-raw") || ""
    };
  }

  function setButtonState(button, active) {
    if (!button) return;

    var label = active ? "Remove from Wishlist" : "Add to Wishlist";
    var text = button.querySelector("[data-if-wishlist-text]");

    button.classList.toggle("is--added", active);
    button.classList.toggle("if-wishlist-btn--active", active);
    button.setAttribute("aria-pressed", active ? "true" : "false");
    button.setAttribute("aria-label", label);
    button.setAttribute("title", label);

    if (text) {
      text.textContent = label;
    }
  }

  function updateAllButtons() {
    document.querySelectorAll("[data-if-wishlist-toggle]").forEach(function (button) {
      var productId = button.getAttribute("data-if-product-id");
      setButtonState(button, isInWishlist(productId));
    });
  }

  function updateCount() {
    var count = getWishlist().length;

    document.querySelectorAll("[data-if-wishlist-count], .if-wishlist-count, .jswcount, .t4s-wis-count, .t4s-count-wishlist").forEach(function (counter) {
      counter.textContent = String(count);

      counter.classList.toggle("t4s-op-0", count === 0);
      counter.classList.toggle("op__0", count === 0);
      counter.classList.toggle("is--hidden", count === 0);

      counter.setAttribute("aria-label", count + " wishlist item" + (count === 1 ? "" : "s"));
    });
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/'/g, "&#039;");
  }

  function getProductUrl(item) {
    return item.url || (item.handle ? "/products/" + item.handle : "#");
  }

  function formatMoney(cents) {
    cents = Number(cents || 0);

    if (!cents) return "";

    return "$" + (cents / 100).toFixed(2);
  }

  function getProductHandle(item) {
    if (item.handle) return item.handle;

    var url = item.url || "";
    var match = url.match(/\/products\/([^?#\/]+)/);

    return match ? match[1] : "";
  }

  function fetchProduct(handle) {
    handle = String(handle || "").trim();

    if (!handle) return Promise.reject(new Error("Missing product handle"));
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", {
      headers: {
        "Accept": "application/json"
      },
      cache: "force-cache"
    }).then(function (response) {
      if (!response.ok) throw new Error("Could not load product " + handle);
      return response.json();
    });

    return productCache[handle];
  }

  function getProductTags(product) {
    if (!product || !product.tags) return [];

    if (Array.isArray(product.tags)) return product.tags;

    return String(product.tags).split(",").map(function (tag) {
      return tag.trim();
    }).filter(Boolean);
  }

  function hasTag(product, tagName) {
    tagName = String(tagName || "").toLowerCase();

    return getProductTags(product).some(function (tag) {
      return String(tag || "").toLowerCase() === tagName;
    });
  }

  function tagContains(product, value) {
    value = String(value || "").toLowerCase();

    return getProductTags(product).some(function (tag) {
      return String(tag || "").toLowerCase().indexOf(value) !== -1;
    });
  }

  function getVariantOptionValue(variant, optionIndex) {
    if (!variant) return "";

    if (variant["option" + (optionIndex + 1)] !== undefined && variant["option" + (optionIndex + 1)] !== null) {
      return variant["option" + (optionIndex + 1)];
    }

    if (Array.isArray(variant.options)) {
      return variant.options[optionIndex] || "";
    }

    if (variant.public_title && optionIndex === 0) {
      return variant.public_title;
    }

    if (variant.title && variant.title !== "Default Title" && optionIndex === 0) {
      return variant.title.split(" / ")[0] || variant.title;
    }

    return "";
  }

  function getOptions(product) {
    if (!product || !product.options) return [];

    return product.options.map(function (option, index) {
      if (typeof option === "string") {
        return {
          name: option,
          position: index + 1,
          values: []
        };
      }

      return option || {
        name: "",
        position: index + 1,
        values: []
      };
    });
  }

  function getSizeOptionIndex(product) {
    var options = getOptions(product);

    for (var i = 0; i < options.length; i++) {
      var optionName = String(options[i].name || "").toLowerCase();

      if (optionName.indexOf("size") !== -1) return i;
    }

    return -1;
  }

  function variantHasInventoryQuantity(variant) {
    return variant && (
      variant.inventory_quantity !== undefined ||
      variant.inventoryQuantity !== undefined
    );
  }

  function variantIsEffectivelyAvailable(variant) {
    if (!variant || variant.available !== true) return false;

    var inventoryManagement = variant.inventory_management || variant.inventoryManagement || "";
    var inventoryPolicy = variant.inventory_policy || variant.inventoryPolicy || "";

    /*
      Important:
      /products/handle.js often does NOT expose inventory_quantity.
      If we treat missing inventory as 0, every available product becomes "Sold Out".
      Only apply the safety buffer when the inventory number is actually present.
    */
    if (variantHasInventoryQuantity(variant)) {
      var inventoryQty = Number(
        variant.inventory_quantity !== undefined
          ? variant.inventory_quantity
          : variant.inventoryQuantity
      );

      if (
        inventoryManagement === "shopify" &&
        inventoryPolicy !== "continue" &&
        !isNaN(inventoryQty) &&
        inventoryQty <= INVENTORY_BUFFER
      ) {
        return false;
      }
    }

    return true;
  }

  function getFirstAvailableVariant(product) {
    var variants = product && product.variants ? product.variants : [];

    return variants.find(variantIsEffectivelyAvailable) || variants.find(function (variant) {
      return variant && variant.available === true;
    }) || variants[0] || null;
  }

  function getSizeValues(product, sizeOptionIndex) {
    var values = [];

    (product.variants || []).forEach(function (variant) {
      var value = getVariantOptionValue(variant, sizeOptionIndex);

      if (value && value !== "Default Title" && values.indexOf(value) === -1) {
        values.push(value);
      }
    });

    return values;
  }

  function findVariantForSize(product, sizeOptionIndex, sizeValue) {
    var variants = product && product.variants ? product.variants : [];

    return variants.find(function (variant) {
      return getVariantOptionValue(variant, sizeOptionIndex) === sizeValue && variantIsEffectivelyAvailable(variant);
    }) || variants.find(function (variant) {
      return getVariantOptionValue(variant, sizeOptionIndex) === sizeValue;
    }) || null;
  }

  function getBadgeHtml(product) {
    var badges = [];
    var title = String(product && product.title || "");

    if (/gift card/i.test(title)) return "";

    if (tagContains(product, "stock: trending")) {
      badges.push('<span class="if-wishlist-badge if-wishlist-badge--trending">Trending</span>');
    } else if (tagContains(product, "stock: selling fast")) {
      badges.push('<span class="if-wishlist-badge if-wishlist-badge--selling-fast">Selling Fast</span>');
    } else if (tagContains(product, "stock: low stock")) {
      badges.push('<span class="if-wishlist-badge if-wishlist-badge--low-stock">Low Stock</span>');
    }

    if (hasTag(product, "final sale")) {
      badges.push('<span class="if-wishlist-badge if-wishlist-badge--final-sale">Final Sale</span>');
    }

    return badges.length ? '<div class="if-wishlist-badge-stack">' + badges.join("") + '</div>' : "";
  }

  function getQuickAddHtml(product) {
    var variants = product && product.variants ? product.variants : [];
    var sizeOptionIndex = getSizeOptionIndex(product);
    var firstVariant = getFirstAvailableVariant(product);

    if (!variants.length || !firstVariant) return "";

    if (sizeOptionIndex === -1 || variants.length === 1) {
      var isAvailable = variantIsEffectivelyAvailable(firstVariant);
      var disabled = isAvailable ? "" : " disabled";
      var classes = "if-wishlist-quick-add__button" + (isAvailable ? "" : " is--unavailable");

      return [
        '<div class="if-wishlist-quick-add">',
          '<button type="button" class="' + classes + '"',
            isAvailable ? ' data-if-wishlist-variant-add="' + escapeAttr(firstVariant.id) + '"' : "",
            disabled,
          '>',
            isAvailable ? "Add to Cart" : "Sold Out",
          '</button>',
        '</div>'
      ].join("");
    }

    var sizeValues = getSizeValues(product, sizeOptionIndex);

    if (!sizeValues.length) {
      var fallbackAvailable = variantIsEffectivelyAvailable(firstVariant);
      return [
        '<div class="if-wishlist-quick-add">',
          '<button type="button" class="if-wishlist-quick-add__button' + (fallbackAvailable ? '' : ' is--unavailable') + '"',
            fallbackAvailable ? ' data-if-wishlist-variant-add="' + escapeAttr(firstVariant.id) + '"' : ' disabled',
          '>',
            fallbackAvailable ? "Add to Cart" : "Sold Out",
          '</button>',
        '</div>'
      ].join("");
    }

    return [
      '<div class="if-wishlist-quick-add">',
        '<div class="if-wishlist-quick-add__title">Select a size</div>',
        '<div class="if-wishlist-quick-add__sizes">',
          sizeValues.map(function (sizeValue) {
            var variant = findVariantForSize(product, sizeOptionIndex, sizeValue);
            var available = variantIsEffectivelyAvailable(variant);
            var variantId = variant && variant.id ? variant.id : "";
            var disabled = available ? "" : " disabled";
            var classes = "if-wishlist-quick-add__size" + (available ? "" : " is--unavailable");

            return [
              '<button type="button" class="' + classes + '"',
                available && variantId ? ' data-if-wishlist-variant-add="' + escapeAttr(variantId) + '"' : "",
                disabled,
              '>',
                escapeHtml(sizeValue),
              '</button>'
            ].join("");
          }).join(""),
        '</div>',
      '</div>'
    ].join("");
  }

  function getCardImage(product, item) {
    if (product && product.featured_image) return product.featured_image;
    if (product && product.images && product.images.length) return product.images[0];
    return item.image || "";
  }

  function getCardPrice(product, item) {
    if (item.price) return item.price;
    if (product && product.price) return formatMoney(product.price);
    return "";
  }

  function getCardTitle(product, item) {
    return product && product.title ? product.title : item.title || "";
  }

  function renderCollectionCard(product, item) {
    var productId = normaliseId(item.id || product.id);
    var title = getCardTitle(product, item);
    var url = getProductUrl(item);
    var image = getCardImage(product, item);
    var price = getCardPrice(product, item);

    return [
      '<article class="if-wishlist-collection-card t4s-product t4s-pr-grid t4s-pr-style1" data-if-wishlist-card="' + escapeAttr(productId) + '">',
        '<div class="if-wishlist-card-inner t4s-product-wrapper">',
          '<div class="if-wishlist-card-media t4s-product-inner t4s-pr t4s-oh">',
            image ? '<a href="' + escapeAttr(url) + '" class="if-wishlist-card-image-link"><img src="' + escapeAttr(image) + '" alt="' + escapeAttr(title) + '" loading="lazy"></a>' : '<a href="' + escapeAttr(url) + '" class="if-wishlist-card-image-link if-wishlist-card-image-link--empty">No image</a>',
            getBadgeHtml(product),
            '<button type="button" class="if-wishlist-card-remove" data-if-wishlist-remove="' + escapeAttr(productId) + '" aria-label="Remove ' + escapeAttr(title) + ' from wishlist"></button>',
            getQuickAddHtml(product),
          '</div>',
          '<div class="if-wishlist-card-info t4s-product-info">',
            '<h3 class="if-wishlist-card-title t4s-product-title"><a href="' + escapeAttr(url) + '">' + escapeHtml(title) + '</a></h3>',
            price ? '<div class="if-wishlist-card-price">' + price + '</div>' : '',
          '</div>',
        '</div>',
      '</article>'
    ].join("");
  }

  function renderFallbackCard(item) {
    var productId = normaliseId(item.id);
    var title = item.title || "";
    var url = getProductUrl(item);
    var image = item.image || "";
    var price = item.price || "";

    return [
      '<article class="if-wishlist-collection-card t4s-product t4s-pr-grid t4s-pr-style1" data-if-wishlist-card="' + escapeAttr(productId) + '">',
        '<div class="if-wishlist-card-inner t4s-product-wrapper">',
          '<div class="if-wishlist-card-media t4s-product-inner t4s-pr t4s-oh">',
            image ? '<a href="' + escapeAttr(url) + '" class="if-wishlist-card-image-link"><img src="' + escapeAttr(image) + '" alt="' + escapeAttr(title) + '" loading="lazy"></a>' : '<a href="' + escapeAttr(url) + '" class="if-wishlist-card-image-link if-wishlist-card-image-link--empty">No image</a>',
            '<button type="button" class="if-wishlist-card-remove" data-if-wishlist-remove="' + escapeAttr(productId) + '" aria-label="Remove ' + escapeAttr(title) + ' from wishlist"></button>',
          '</div>',
          '<div class="if-wishlist-card-info t4s-product-info">',
            '<h3 class="if-wishlist-card-title t4s-product-title"><a href="' + escapeAttr(url) + '">' + escapeHtml(title) + '</a></h3>',
            price ? '<div class="if-wishlist-card-price">' + price + '</div>' : '',
            '<a href="' + escapeAttr(url) + '" class="if-wishlist-card-view-fallback">View Product</a>',
          '</div>',
        '</div>',
      '</article>'
    ].join("");
  }

  function findProductSlot(productId) {
    var slots = document.querySelectorAll("[data-if-wishlist-product-slot]");

    for (var i = 0; i < slots.length; i++) {
      if (normaliseId(slots[i].getAttribute("data-if-wishlist-product-slot")) === normaliseId(productId)) {
        return slots[i];
      }
    }

    return null;
  }

  function renderProductSlots(items) {
    items.forEach(function (item) {
      var productId = normaliseId(item.id);
      var handle = getProductHandle(item);
      var slot = findProductSlot(productId);

      if (!slot) return;

      if (!handle) {
        slot.innerHTML = renderFallbackCard(item);
        return;
      }

      fetchProduct(handle).then(function (product) {
        var freshSlot = findProductSlot(productId);
        if (!freshSlot) return;

        freshSlot.innerHTML = renderCollectionCard(product, item);
      }).catch(function () {
        var freshSlot = findProductSlot(productId);
        if (!freshSlot) return;

        freshSlot.innerHTML = renderFallbackCard(item);
      });
    });
  }

  function getWishlistPageHtml(items) {
    var count = items.length;

    if (!count) {
      return [
        '<section class="if-wishlist-page if-wishlist-page--empty">',
          '<div class="if-wishlist-empty">',
            '<div class="if-wishlist-empty__icon" aria-hidden="true">♡</div>',
            '<h1>Your wishlist is empty</h1>',
            '<p>Start saving pieces you love by tapping the heart on a product page.</p>',
            '<a href="https://www.imaginefashion.com.au/collections/shop-online-womens-clothing" class="if-wishlist-primary-btn">Start Shopping</a>',
          '</div>',
        '</section>'
      ].join("");
    }

    return [
      '<section class="if-wishlist-page if-wishlist-page--collection">',
        '<div class="if-wishlist-collection-header">',
          '<div>',
            '<p class="if-wishlist-kicker">Saved Styles</p>',
            '<h1 class="if-wishlist-title">Your Wishlist</h1>',
            '<p class="if-wishlist-subtitle">' + count + ' saved ' + (count === 1 ? 'style' : 'styles') + ' ready when you are.</p>',
          '</div>',
          '<div class="if-wishlist-toolbar">',
            '<a href="https://www.imaginefashion.com.au/collections/shop-online-womens-clothing" class="if-wishlist-secondary-btn">Continue Shopping</a>',
            '<button type="button" class="if-wishlist-clear" data-if-wishlist-clear>Clear Wishlist</button>',
          '</div>',
        '</div>',
        '<div class="if-wishlist-collection-grid">',
          items.map(function (item) {
            return [
              '<div class="if-wishlist-product-slot" data-if-wishlist-product-slot="' + escapeAttr(item.id) + '">',
                '<div class="if-wishlist-card-skeleton">',
                  '<div class="if-wishlist-card-skeleton__image"></div>',
                  '<div class="if-wishlist-card-skeleton__line"></div>',
                  '<div class="if-wishlist-card-skeleton__line if-wishlist-card-skeleton__line--short"></div>',
                '</div>',
              '</div>'
            ].join("");
          }).join(""),
        '</div>',
      '</section>'
    ].join("");
  }

  function renderWishlistPage(force) {
    var container = document.querySelector("[data-if-wishlist-page]");
    if (!container) return;

    var items = getWishlist();
    var signature = items.map(function (item) {
      return normaliseId(item.id);
    }).join("|");

    if (!force && signature === lastWishlistPageSignature) return;

    lastWishlistPageSignature = signature;
    container.innerHTML = getWishlistPageHtml(items);

    if (items.length) {
      renderProductSlots(items);
    }
  }

  function refreshWishlistUi(options) {
    options = options || {};

    updateAllButtons();
    updateCount();
    renderWishlistPage(options.forceRender === true);
  }

  function refreshWishlistUiWithRetries(options) {
    refreshWishlistUi(options);

    requestAnimationFrame(function () {
      refreshWishlistUi(options);
    });

    [80, 250].forEach(function (delay) {
      setTimeout(function () {
        refreshWishlistUi(options);
      }, delay);
    });
  }

  function refreshCart(data) {
    function renderSections(sections) {
      if (!sections) return;

      if (sections.mini_cart) {
        var doc = new DOMParser().parseFromString(sections.mini_cart, "text/html");
        var freshSection = doc.querySelector("#shopify-section-mini_cart");
        var currentSection = document.querySelector("#shopify-section-mini_cart");
        var freshCart = doc.querySelector("#t4s-mini_cart");
        var currentCart = document.querySelector("#t4s-mini_cart");

        if (freshSection && currentSection) {
          currentSection.innerHTML = freshSection.innerHTML;
        } else if (freshCart && currentCart) {
          currentCart.outerHTML = freshCart.outerHTML;
        }
      }

      if (sections.cart_data) {
        var raw = sections.cart_data;
        var match = raw.match(/\[t4s_split1\]([\s\S]*?)\[t4s_split1\]/);

        if (match) {
          var parts = match[1].split("[t4s_split2]");
          var count = parts[0] || "0";
          var priceHtml = parts[1] || "";

          document.querySelectorAll("[data-cart-count]").forEach(function (el) {
            el.textContent = count;

            if (parseInt(count, 10) > 0) {
              el.classList.remove("t4s-op-0");
            } else {
              el.classList.add("t4s-op-0");
            }
          });

          document.querySelectorAll("[data-cart-tt-price]").forEach(function (el) {
            el.innerHTML = priceHtml;
          });
        }
      }

      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("t4s:cart:updated", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }

    if (data && data.sections) {
      renderSections(data.sections);
      return Promise.resolve();
    }

    return fetch("/cart?sections=mini_cart,cart_data&_=" + Date.now(), {
      method: "GET",
      headers: {
        "Accept": "application/json"
      },
      cache: "no-store"
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        renderSections(sections);
      });
  }

  function openCartDrawer() {
    setTimeout(function () {
      var cartLink = document.querySelector(".t4s-site-nav__cart a[data-drawer-options]");
      if (cartLink) cartLink.click();
    }, 100);
  }

  function addVariantToCart(button) {
    if (!button || button.classList.contains("is--adding") || button.classList.contains("is--added") || button.disabled) return;

    var variantId = button.getAttribute("data-if-wishlist-variant-add");
    if (!variantId) return;

    var originalHtml = button.innerHTML;

    button.classList.add("is--adding");
    button.innerHTML = '<span class="if-wishlist-spinner"></span>';

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId, 10),
            quantity: 1
          }
        ],
        sections: "cart_data,mini_cart",
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Add to cart failed");
        return response.json();
      })
      .then(function (data) {
        button.classList.remove("is--adding");
        button.classList.add("is--added");
        button.innerHTML = "✓";

        refreshCart(data);
        openCartDrawer();

        setTimeout(function () {
          button.classList.remove("is--added");
          button.innerHTML = originalHtml;
        }, 1500);
      })
      .catch(function () {
        button.classList.remove("is--adding");
        button.innerHTML = originalHtml;
      });
  }

  document.addEventListener("click", function (event) {
    var toggle = event.target.closest("[data-if-wishlist-toggle]");

    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      var product = getProductFromButton(toggle);

      if (!product.id) return;

      if (isInWishlist(product.id)) {
        removeFromWishlist(product.id);
      } else {
        addToWishlist(product);
      }

      refreshWishlistUiWithRetries({ forceRender: true });

      document.dispatchEvent(new CustomEvent("imagine:wishlist:updated", {
        detail: {
          count: getWishlist().length,
          productId: product.id,
          inWishlist: isInWishlist(product.id)
        }
      }));

      return;
    }

    var variantAddButton = event.target.closest("[data-if-wishlist-variant-add]");

    if (variantAddButton) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      addVariantToCart(variantAddButton);
      return;
    }

    var removeButton = event.target.closest("[data-if-wishlist-remove]");

    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      removeFromWishlist(removeButton.getAttribute("data-if-wishlist-remove"));

      refreshWishlistUiWithRetries({ forceRender: true });

      document.dispatchEvent(new CustomEvent("imagine:wishlist:updated", {
        detail: {
          count: getWishlist().length
        }
      }));

      return;
    }

    var clearButton = event.target.closest("[data-if-wishlist-clear]");

    if (clearButton) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      clearWishlist();
      refreshWishlistUiWithRetries({ forceRender: true });

      document.dispatchEvent(new CustomEvent("imagine:wishlist:updated", {
        detail: {
          count: 0
        }
      }));
    }
  }, true);

  document.addEventListener("DOMContentLoaded", function () {
    refreshWishlistUiWithRetries({ forceRender: true });
  });

  document.addEventListener("shopify:section:load", function () {
    refreshWishlistUiWithRetries({ forceRender: true });
  });

  document.addEventListener("theme:section:load", function () {
    refreshWishlistUiWithRetries({ forceRender: true });
  });

  document.addEventListener("turbo:load", function () {
    refreshWishlistUiWithRetries({ forceRender: true });
  });

  window.addEventListener("pageshow", function () {
    refreshWishlistUiWithRetries({ forceRender: true });
  });

  document.addEventListener("imagine:wishlist:refresh", function () {
    refreshWishlistUiWithRetries({ forceRender: true });
  });

  window.addEventListener("storage", function (event) {
    if (!event || event.key === STORAGE_KEY) {
      refreshWishlistUiWithRetries({ forceRender: true });
    }
  });

  window.ImagineWishlist = {
    get: getWishlist,
    add: function (product) {
      var result = addToWishlist(product);
      refreshWishlistUiWithRetries({ forceRender: true });
      return result;
    },
    remove: function (productId) {
      var result = removeFromWishlist(productId);
      refreshWishlistUiWithRetries({ forceRender: true });
      return result;
    },
    clear: function () {
      var result = clearWishlist();
      refreshWishlistUiWithRetries({ forceRender: true });
      return result;
    },
    has: isInWishlist,
    refresh: function () {
      refreshWishlistUiWithRetries({ forceRender: true });
    }
  };
})();
